/* --------------------------------------------------------------------------
   Tula Blue custom behavior JS.
   Last updated: 2026-10-13

   1. Hero video viewport gating (sections/custom-hero.liquid)

      A <video autoplay> has no native viewport-based deferral the way
      <img loading="lazy"> does: the browser starts streaming it as soon as
      the element exists and autoplay is allowed, no matter where it sits on
      the page. That means every copy of the custom-hero section further
      down a page was pulling down real video bytes (not just the poster)
      even if a visitor never scrolled anywhere near it.

      The fix: the `autoplay` attribute has been removed from the video tag
      in sections/custom-hero.liquid. Instead, an IntersectionObserver here
      calls .play() only once a hero video is actually about to enter the
      viewport, and .pause() once it scrolls back out. This applies the same
      way whether the block is the true top-of-page hero or a reused
      explainer block lower down, so it holds up no matter how many of
      these get added to a page.
   -------------------------------------------------------------------------- */
(function () {
  if (window.__tbHeroVideoObserverInit) return;
  window.__tbHeroVideoObserverInit = true;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) {
            video.play().catch(function () {
              /* Autoplay can be rejected in rare cases; the poster stays visible behind it. */
            });
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: "200px 0px", threshold: 0.01 }
  );

  function observeHeroVideos() {
    document.querySelectorAll(".hero-video-el:not([data-tb-observed])").forEach(function (video) {
      video.setAttribute("data-tb-observed", "true");
      io.observe(video);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeHeroVideos);
  } else {
    observeHeroVideos();
  }

  /* Re-scan when the theme editor swaps sections in/out. */
  document.addEventListener("shopify:section:load", observeHeroVideos);
})();
